(function () {
  'use strict';
  var ATTR = 'data-goc-estimated-delivery';
  var css = '[data-goc-estimated-delivery]{display:flex;align-items:center;gap:8px;padding:12px 14px;margin:12px 0;border:1px solid #e4d8dd;border-left:3px solid #681d39;border-radius:5px;background:#fbf8f9;color:#512036;font:inherit;font-size:13px;line-height:1.5}[data-goc-estimated-delivery] .goc-delivery-icon{font-size:19px;line-height:1;flex:none}[data-goc-estimated-delivery] .goc-delivery-text{font-weight:600}';
  var style = document.createElement('style');
  style.textContent = css;
  (document.head || document.documentElement).appendChild(style);

  function datePlus(days) {
    var d = new Date();
    d.setHours(12, 0, 0, 0);
    d.setDate(d.getDate() + days);
    return d;
  }
  function locale() {
    var lang = String(document.documentElement.lang || (window.Shopify && window.Shopify.locale) || 'en').toLowerCase();
    return lang.indexOf('fr') === 0 ? 'fr' : 'en';
  }
  function label() {
    var fr = locale() === 'fr';
    var a = datePlus(10), b = datePlus(18);
    var fmt = new Intl.DateTimeFormat(fr ? 'fr-CA' : 'en-US', {day:'numeric', month:'long'});
    function d(v) {
      var text = fmt.format(v);
      return fr && v.getDate() === 1 ? text.replace(/^1\b/, '1er') : text;
    }
    return fr
      ? 'Livraison gratuite estimée entre le ' + d(a) + ' et le ' + d(b)
      : 'Estimated free delivery between ' + d(a) + ' and ' + d(b);
  }
  function makeBlock() {
    var div = document.createElement('div');
    div.setAttribute(ATTR, '');
    div.setAttribute('role', 'note');
    var icon = document.createElement('span');
    icon.className = 'goc-delivery-icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = '🚚';
    var text = document.createElement('span');
    text.className = 'goc-delivery-text';
    text.textContent = label();
    div.appendChild(icon);
    div.appendChild(text);
    return div;
  }
  function insertBefore(parent, target) {
    if (!parent || parent.querySelector('[' + ATTR + ']')) return;
    parent.insertBefore(makeBlock(), target || parent.firstChild);
  }
  function product() {
    if (!document.body || !/(^|\s)template-product(\s|$)/.test(document.body.className)) return;
    var details = document.querySelector('.product-single__details .form__wrapper');
    if (!details) return;
    var form = details.querySelector('.product__form__wrapper');
    if (form) insertBefore(details, form);
  }
  var cartHasItems = null;
  var inflight = false, pending = null;
  function renderCarts() {
    document.querySelectorAll('[data-cart-drawer-body]').forEach(function(el){
      var old = el.querySelector('[' + ATTR + ']');
      if (cartHasItems === false) {if (old) old.remove();return;}
      if (cartHasItems === true) insertBefore(el, el.firstChild);
    });
    document.querySelectorAll('[data-cart-page] .cart__content').forEach(function(el){
      var old = el.querySelector('[' + ATTR + ']');
      if (cartHasItems === false) {if (old) old.remove();return;}
      if (cartHasItems === true) {
        var title = el.querySelector('.cart__title');
        insertBefore(el, title ? title.nextSibling : el.firstChild);
      }
    });
  }
  function fetchCart() {
    if (inflight) return;
    inflight = true;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', {headers:{Accept:'application/json'}})
      .then(function(r){if(!r.ok) throw new Error('Cart unavailable');return r.json();})
      .then(function(cart){cartHasItems = (Number(cart.item_count) || 0) > 0;renderCarts();})
      .catch(function(){})
      .finally(function(){inflight = false;});
  }
  function refreshSoon(delay) {
    if (pending) clearTimeout(pending);
    pending = setTimeout(function(){pending = null;product();fetchCart();},delay || 200);
  }
  function init() {
    product();
    fetchCart();
    new MutationObserver(function(mutations){
      var needsProduct = false, needsCart = false;
      mutations.forEach(function(m){
        Array.prototype.forEach.call(m.addedNodes || [], function(node){
          if (node.nodeType !== 1 || node.hasAttribute && node.hasAttribute(ATTR)) return;
          if (node.matches && (node.matches('.product-single__details,[data-cart-drawer-body],[data-cart-page]') || node.querySelector && node.querySelector('.product-single__details,[data-cart-drawer-body],[data-cart-page]'))) {
            needsProduct = true; needsCart = true;
          } else if (node.closest && node.closest('[data-cart-drawer-body],[data-cart-page]')) {
            needsCart = true;
          }
        });
        Array.prototype.forEach.call(m.removedNodes || [], function(node){
          if (node.nodeType === 1 && node.closest && node.closest('[data-cart-drawer-body],[data-cart-page]')) needsCart = true;
        });
      });
      if (needsProduct) product();
      if (needsCart) refreshSoon(250);
    }).observe(document.body, {childList:true,subtree:true});
    document.addEventListener('cart:refresh', function(){refreshSoon(200);});
    document.addEventListener('cart:updated', function(){refreshSoon(200);});
    document.addEventListener('click',function(e){
      if (e.target && e.target.closest && e.target.closest('[data-cart-drawer-toggle],[data-quantity-button],[data-item-remove],[name="add"]')) refreshSoon(450);
    },true);
    document.addEventListener('shopify:section:load',function(){refreshSoon(200);});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();